module.exports = __webpack_public_path__ + "static/tr-panelvan-6af4ec61a9c3b322bcca65a42de98c34.png";